module.exports = __webpack_public_path__ + "img/banner3_4.531687b3.jpg";